import React from 'react';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ArrowForwardIos';
import ChevronLeftIcon from '@mui/icons-material/ArrowBackIos';
import { getConfigAmbiente } from '../../services/authentication/auth';
import imageDefault from '../../assets/img/botao-fechar.svg';

const Navbar = ({ menuOpen, handleDrawerToggle, onlySmallScreen }) => {
  const config = getConfigAmbiente();
  const logo =
    config && config.imagens && config.imagens.LOGO && config.imagens.LOGO !== 'image-default'
      ? config.imagens.LOGO
      : imageDefault;

  return (
    <AppBar
      position="fixed"
      className="nav-bar-principal"
      sx={{
        zIndex: 2000,
        minHeight: '68px',
        backgroundColor: '#ffffff'
      }}
    >
      <Toolbar>
        <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2 }} className="nabvar-btn">
          {onlySmallScreen ? (
            <MenuIcon />
          ) : (
            <>
              <div
                className="img-logo-main-one7"
                style={{
                  backgroundImage: `url(${logo})`
                }}
                alt="Logo"
              />
              {menuOpen ? (
                <ChevronLeftIcon sx={{ fontSize: '20px', fill: '#333333' }} />
              ) : (
                <ChevronRightIcon sx={{ fontSize: '20px', fill: '#333333' }} />
              )}
            </>
          )}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
